<template>
  <div id="copyright">
    <span @click="scrollTop">
      <router-link :to="{ name: 'home' }" id="copyright-link">
          <icon name="copyright" scale="1"></icon> 2017 {{ studio308.name }}
      </router-link> -
    </span>
    <a @click="scrollTop" class="scroll-top pointer easy">TOP <span class="arrow-up">↑</span></a>
  </div>
</template>

<script>
import DataStore from '@/storage/data'
export default {
  name: 'copyright',
  data () {
    return {
      studio308: DataStore.studio308
    }
  },
  methods: {
    scrollTop () {
      this.$scrollTo('html, body')
    }
  }
}
</script>

<style lang="sass">
  @import ../assets/styles/scss/variables.scss

  #copyright
    font-size: 1.3em
    text-transform: uppercase

    > span > #copyright-link
      text-decoration: none
      color: $grey
      font-size: .8em

      &:hover
        color: $lightGrey

  .scroll-top
    text-decoration: none
    color: $grey
    font-size: .8em
    transition: all 0.3s ease-in-out

    &:hover
      color: $mainColor !important

    &:active
      color: $mainColorDark !important

  .arrow-up
    font-size: .85em
  
</style>



// WEBPACK FOOTER //
// Copyright.vue?a7c360f0